import Qs from 'qs';
import axios from 'axios';
import gsap from 'gsap';
import Plyr from 'plyr';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { loaderClass, scrollInstance } from './main';
import { detectedDevice } from 'detected-device';

gsap.registerPlugin(ScrollTrigger);

const asyncAjaxCall = async (action, myData, onProgress = null) => {
	let res;

	if(action == 'upload_file'){

		res = await axios.post(custom_ajax_obj.url, myData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			},
			onUploadProgress: (event) => {
				if (onProgress && event.lengthComputable) {
					const percent = Math.round((event.loaded / event.total) * 100);
					onProgress(percent);
				}
			}
		})

	}else{

		let data = {
			action,
			data: myData
		}
		res = await axios.post(custom_ajax_obj.url, Qs.stringify(data))
		
	}
	
	return res
}

const TL_BY_EL = new WeakMap();

const pageTransition = async (action) => {
    const container = document.querySelector('.page--transition');
    if (!container) return Promise.resolve();
    const tl = gsap.timeline({ defaults: { ease: "power3.inOut" } });

    if(action == 'enter') {
        tl.set(container, { autoAlpha: 1 })
        .set(container.querySelector('.bg .red'), { clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)' })
        .set(container.querySelector('.bg .blue'), { clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)' })
        .set(container.querySelector('.logo'), { autoAlpha: 0, y: '15vh' })
        .to(container.querySelector('.bg .red'), { duration: 1.2, clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' })
        .to(container.querySelector('.bg .blue'), { duration: 1.2, clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' }, "<")
        .to(container.querySelector('.logo'), { duration: .6, autoAlpha: 1, y: 0, ease: "power4.out" }, "<0.6")
        .to(container, { duration: .6, autoAlpha: 1 }, "<0.3");
    }
    if(action == 'exit') {
        tl.to(container.querySelector('.bg .blue'), { duration: 1.2, clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)', ease: "power3.in" })
        .to(container.querySelector('.bg .red'), { duration: 1.2, clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)', ease: "power3.in" }, "<")
        .to(container.querySelector('.logo'), { duration: .45, autoAlpha: 0, y: '-15vh', ease: "power4.in" }, "<.7")
        .set(container, { autoAlpha: 0 }, ">1");
    }

    return tl;
};

const validateEmail = (email) => {
	let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
}

const setBlockRatio = async (element, ref, ratio, returnValue = false) => {

	const img = element.querySelector('img');
	if (img) {
		await new Promise(resolve => {
			if (img.complete) return resolve();
			img.onload = resolve;
			img.onerror = resolve; // fallback
		});
	}

	let elementDimensionOri, elementDimensionRes;
	if(!returnValue){
		if(ref == 'width'){
			elementDimensionOri = element.getBoundingClientRect().width
			elementDimensionRes = elementDimensionOri*ratio;

			element.style.height = elementDimensionRes + 'px';
		}
		if(ref == 'height'){
			elementDimensionOri = element.getBoundingClientRect().height
			elementDimensionRes = elementDimensionOri*ratio;

			element.style.width = elementDimensionRes + 'px';
		}
	}else{
		if(ref == 'width'){
			elementDimensionOri = element.getBoundingClientRect().width
			elementDimensionRes = elementDimensionOri*ratio;
		}
		if(ref == 'height'){
			elementDimensionOri = element.getBoundingClientRect().height
			elementDimensionRes = elementDimensionOri*ratio;
		}
		return elementDimensionRes
	}
}

const scrollCardsComponent = (section) => {
    if(detectedDevice.isAllMobileDevices()) return;

    const container = section.querySelector('.wrapper')
    let c = [0, 0, 0]
    let sums = [1, 1, 1];
    if(container.querySelector('.js-counter') != null){
        let jsCounters = container.querySelectorAll('.js-counter')
        jsCounters.forEach((counter, i) => {
            let target = Number(counter.getAttribute('data-target'))
            if(target > 1000){
                sums[i] = 35
            }
            else if(target > 500){
                sums[i] = 10
            }
            else{
                sums[i] = 1
            }
        })
    }
	const cards = gsap.utils.toArray(section.querySelectorAll('.cards .card'));
    let start
    if(section.classList.contains('sticky--cards')){

        let startOff = '80%';
        let endOff = '80%';

        if(section.hasAttribute('start')){
            startOff = section.getAttribute('start') + '%';
        }
        if(section.hasAttribute('end')){
            endOff = section.getAttribute('end') + '%';
        }

        if(section.classList.contains('start--before')){
            start = "top center";
        }
        else{
            start = "top " + startOff;
        }
        gsap.registerPlugin(ScrollTrigger)
        const root = document.documentElement
        // let headerH = getComputedStyle(root).getPropertyValue('--header-height')
        const tl = gsap.timeline({
            defaults: { ease: "none", duration: 1 },
            scrollTrigger: {
                trigger: container,
                start,
                end: "bottom " + endOff,
                scrub: true,
                pin: false,
                markers: false,
                onUpdate: (self) => {
                    if(container.querySelector('.js-counter') != null){
                        let jsCounters = container.querySelectorAll('.js-counter')
                        jsCounters.forEach((counter, i) => {
                            let target = Number(counter.getAttribute('data-target'))
                            if(self.progress >0.7){
                                setInterval(() => {
                                    if(c[i] < target){
                                        // c++
                                        c[i] = c[i] + sums[i]
                                        counter.innerHTML = c[i]
                                    }
                                    else {

                                        counter.innerHTML = target
                                    }
                                }, 100)

                            }
                        })
                    }
                }

            }
        });

        cards.forEach((card) => {
            tl.to(card, { x: 0, duration: 1, ease: 'power2.out' }, ">-.875");
            // console.log(tl.progress());
        });
    }

    // if(section.classList.contains('sticky--cards') && !section.classList.contains('start--before')){
    //     gsap.registerPlugin(ScrollTrigger);
    //     const root = document.documentElement;
    //     let headerH = getComputedStyle(root).getPropertyValue('--header-height');
    //     let c = 0
    //     const tl = gsap.timeline({
    //         defaults: { ease: "none", duration: 1 }, // 1+1+1 = 3 "unità" -> 1/3 ciascuno
    //         scrollTrigger: {
    //             trigger: container,
    //             start: "top 80px",
    //             end: "bottom 100px",
    //             scrub: true,
    //             pin: true,
    //             markers: false,
    //             onUpdate: (self) => {
    //                 // console.log("Scroll progress:", self.progress);
    //                 if(container.querySelector('.js-counter') != null){
    //                     let jsCounters = container.querySelectorAll('.js-counter')
    //                     let sum = 1
    //                     jsCounters.forEach(counter => {
    //                         let target = Number(counter.getAttribute('data-target'))
    //                         if(target > 1000){
    //                             sum = 10
    //                         }
    //                         // console.log(target);
    //                         if(self.progress >0.7){
    //                             setInterval(() => {
    //                                 if(c <= target){
    //                                     // c++
    //                                     c += sum
    //                                     // console.log(c)
    //                                     counter.innerHTML = c
    //                                 }
    //                             }, 100)

    //                         }
    //                     })
    //                 }
    //             }

    //         }
    //     });

    //     cards.forEach((card) => {
    //         tl.to(card, { x: 0, duration: 1, ease: 'power2.out' }, ">-.875");
    //         // console.log(tl.progress());
    //     });
    // }

    // if(section.classList.contains('sticky--cards') && section.classList.contains('start--before')){
    //     // console.log('here')
    //     gsap.registerPlugin(ScrollTrigger);
    //     const root = document.documentElement;
    //     let headerH = getComputedStyle(root).getPropertyValue('--header-height');
    //     let c = 0
    //     const tl = gsap.timeline({
    //         defaults: { ease: "none", duration: 1 }, // 1+1+1 = 3 "unità" -> 1/3 ciascuno
    //         scrollTrigger: {
    //             trigger: container,
    //             start: "top center",
    //             end: "bottom 100px",
    //             scrub: true,
    //             pin: true,
    //             markers: false,
    //             onUpdate: (self) => {
    //                 // console.log("Scroll progress:", self.progress);
    //                 if(container.querySelector('.js-counter') != null){
    //                     let jsCounters = container.querySelectorAll('.js-counter')
    //                     jsCounters.forEach(counter => {
    //                         let target = Number(counter.getAttribute('data-target'))
    //                         // console.log(target);
    //                         if(self.progress >0.7){
    //                             setInterval(() => {
    //                                 if(c <= target){
    //                                     c += 100
    //                                     console.log(c)
    //                                     counter.innerHTML = c
    //                                 }
    //                             }, 100)

    //                         }
    //                     })
    //                 }
    //             }

    //         }
    //     });

    //     cards.forEach((card) => {
    //         tl.to(card, { x: 0, duration: 1, ease: 'power2.out' }, ">-.875");
    //         // console.log(tl.progress());
    //     });
    // }

    /* if(section.classList.contains('calculate--height')){
        cards.forEach(card => {
            if(card.classList.contains('empty')) return;
            setBlockRatio(card, 'width', 0.75)
        });
        window.addEventListener('resize', () => {
            cards.forEach(card => {
                if(card.classList.contains('empty')) return;
                setBlockRatio(card, 'width', 0.75)
            });
        });
    } */
}

const simulateHover = (element) => {
    if(!element) return;

    let button = element.querySelector('.' + element.getAttribute('simulation'));

    element.addEventListener('mouseenter', () => button.classList.add('hover-simulation'));
    element.addEventListener('mouseleave', () => button.classList.remove('hover-simulation'));
}

//Aggiunta Lollo 
let winsize = {
    width: window.innerWidth,
    height: window.innerHeight
}
function calcWinsize() {
    return { width: window.innerWidth, height: window.innerHeight }
}
winsize = calcWinsize()

window.addEventListener('resize', () => {
    winsize = calcWinsize()
})

let mousePos = {
    x:winsize/2,
    y:winsize/2
}
const getMousePos = (ev) => {
    let posx = 0;
    let posy = 0;
    if (!ev) ev = window.event;
    if (ev.pageX || ev.pageY) {
        posx = ev.pageX;
        posy = ev.pageY;
    }
    else if (ev.clientX || ev.clientY) 	{
        posx = ev.clientX + body.scrollLeft + docEl.scrollLeft;
        posy = ev.clientY + body.scrollTop + docEl.scrollTop;
    }
    return {x: posx, y: posy};

}
window.addEventListener('mousemove', e => {
    mousePos = getMousePos(e);
})

const calculateRevealButton = (button) => {
    setTimeout(() => {
        let spanWidth = button.querySelector('.button-wrapper .hidden-text span').getBoundingClientRect().width;
        button.setAttribute('style', `--button-component-reveal-width: ${spanWidth}px`);
    }, 500);
}

const servicesImagesParallax = (section) => {
    if(detectedDevice.isAllMobileDevices()) return;
    
    let trigger = section.querySelector('.wrapper');
    const images = section?.querySelectorAll('.images--cont .image');
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: section,
            start: 'top 60%',
            end: 'bottom bottom',
            scrub: 1,
            invalidateOnRefresh: true
        }
    });

    tl.fromTo(images[0], 
        { y: '-55vh' }, 
        { y: '0vh', duration: 1 }, 
        0 // Inizia al tempo 0
    )
    .fromTo(images[1], 
        { y: '25vh' }, 
        { y: '0vh', duration: 1 }, 
        0 // Inizia con leggero ritardo
    )
    .fromTo(images[2], 
        { scale: 0.8, opacity: 0.7 }, 
        { scale: 1, opacity: 1, duration: 1 }, 
        0
    )
    .fromTo(images[3], 
        { x: '100%' }, 
        { x: '0%', duration: 1 }, 
        0
    );
}

const informationsPanel = () => {
    const panel = document.querySelector('.request-informations--panel');
    const buttons = document.querySelectorAll('.open--info-panel');

    if(!panel) return;

    buttons.forEach(button => {
        button.addEventListener('click', async () => {
            if(!loaderClass.isLoaderOpen) await loaderClass.open(false);

            await gsap.to(panel, { duration: 0, autoAlpha: 1, ease: 'power2.out' });
            await gsap.to(panel.querySelector('.panel--wrapper'), { duration: 0, x: 0, ease: 'power2.out' });
            await gsap.to(panel.querySelectorAll('.panel--wrapper .panel-element'), { duration: 0.5, x: 0, stagger: 0.05, ease: 'power2.out' });
        });
    });

    panel.querySelector('.panel--overlay').addEventListener('click', async () => {
        await gsap.to(panel.querySelectorAll('.panel--wrapper .panel-element'), { duration: 0.5, x: '100%', stagger: -0.05, ease: 'power2.out' });
        await gsap.to(panel.querySelector('.panel--wrapper'), { duration: 0, x: '100%', ease: 'power2.out' });
        await gsap.to(panel, { duration: 0, autoAlpha: 0, ease: 'power2.out' });
        if(loaderClass.isLoaderOpen) await loaderClass.close();
    });

    panel.querySelector('.panel--wrapper .panel-close').addEventListener('click', async () => {
        await gsap.to(panel.querySelectorAll('.panel--wrapper .panel-element'), { duration: 0.5, x: '100%', stagger: -0.05, ease: 'power2.out' });
        await gsap.to(panel.querySelector('.panel--wrapper'), { duration: 0, x: '100%', ease: 'power2.out' });
        await gsap.to(panel, { duration: 0, autoAlpha: 0, ease: 'power2.out' });
        if(loaderClass.isLoaderOpen) await loaderClass.close();
    });

    panel.querySelectorAll('.panel--wrapper .panel-bottom .card').forEach(card => {
        card.addEventListener('click', async () => {
            let ref = card.getAttribute('modal-await');

            await gsap.to(panel.querySelectorAll('.panel--wrapper .panel-element'), { duration: 0.5, x: '100%', stagger: -0.05, ease: 'power2.out' });
            await gsap.to(panel.querySelector('.panel--wrapper'), { duration: 0, x: '100%', ease: 'power2.out' });
            await gsap.to(panel, { duration: 0, autoAlpha: 0, ease: 'power2.out' });

            document.dispatchEvent(new CustomEvent('openModal', {
                detail: { ref },
                bubbles: true
            }));
        });
    })
}

const customVideoBlock = (element) => {

	const player = new Plyr(element.querySelector('.player'), {
		controls: ['play-large', 'play', 'progress', 'fullscreen', 'mute', 'current-time'],
		resetOnEnd: true,
		hideControls: true,
		vimeo: {
			byline: false,
			portrait: false,
			title: false,
			controls: false
		},
		youtube: {
			noCookie: true,
			modestbranding: 1,
			rel: 0,
			iv_load_policy: 3,
			controls: 0
		},
	})

	/* player.on('playing', (event) => {
		setCursorClass(element, 'pause-video')
		mouseCursor.updateModifiers()
		mouseCursor.forceMouseReenter(element)
	});
	player.on('ended', (event) => {
		setCursorClass(element, 'play-video')
		mouseCursor.updateModifiers()
		mouseCursor.forceMouseReenter(element)
	});
	player.on('pause', (event) => {
		setCursorClass(element, 'play-video')
		mouseCursor.updateModifiers()
		mouseCursor.forceMouseReenter(element)
	}); */
}

const setItemWithExpiry = (key, value, ttlMs) => {
  const now = new Date();

  const item = {
    value: value,
    expiry: now.getTime() + ttlMs,
  };

  localStorage.setItem(key, JSON.stringify(item));
}

const getItemWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  const item = JSON.parse(itemStr);
  const now = new Date();
  
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}

export { asyncAjaxCall, pageTransition, validateEmail, setBlockRatio, scrollCardsComponent, simulateHover, calculateRevealButton, servicesImagesParallax, informationsPanel, customVideoBlock, setItemWithExpiry, getItemWithExpiry };